import { useFavoriteMutation } from './mutations/favorites/useFavoriteMutation'
import type { Elemental } from '~~/src/types/elemental'

export const useFavorite = (elemental: Elemental) => {
  const firebaseUser = useUser()
  const router = useRouter()
  const isAuth = computed(() => firebaseUser.value !== null)
  const { mutate, isPending } = useFavoriteMutation()
  const isFavorite = computed(() => {
    return elemental ? elemental.isFavorite : false
  })

  const favorite = (isFavorite?: boolean) => {
    if (!isAuth.value) {
      const path = useGetLoginURL()
      return router.push(path)
    }

    mutate({
      elemental: {
        ...unref(elemental),
        isFavorite,
      },
    })
  }

  return {
    isFavorite,
    favorite,
    isPending,
  }
}
